export default "__VITE_ASSET__C3oA_Zlm__"